// extracted by mini-css-extract-plugin
export default {"icon":"FileType_icon__-8uqq"};